import { formatDate, isoDateStringToDate } from 'lib/riskbase';
import React from 'react';
import { AseFieldInstanceCheckAvailability } from 'store/assessments/types';
import { getCheckAvailabilityCategory } from '../Explorer/utils';
import { UI_DATE_FORMAT_SHORT, UI_TIME_FORMAT } from 'lib/constants';
import { addSeconds } from 'date-fns';
import { theme } from 'lib/theme';
import { View } from 'react-native';
import { Txt } from 'components/Txt';
import { Icon, ICONS } from 'components/Icon';

export const InstanceCheckAvailabilityBadge: React.FC<{
  availability: AseFieldInstanceCheckAvailability[];
  showIcon?: boolean;
}> = ({ availability, showIcon }) => {
  const [firstAvailability] = availability;
  if (!firstAvailability) {
    return null;
  }

  const startDate = isoDateStringToDate(firstAvailability.startDateTime);
  const now = new Date();

  const availabilityCategory = getCheckAvailabilityCategory(
    startDate,
    now,
    true,
  );

  if (!availabilityCategory) {
    return null;
  }

  const showDatePrefix = availabilityCategory.text === 'Next 7 Days';
  const startTime = formatDate(startDate, UI_TIME_FORMAT);
  const endTime = formatDate(
    addSeconds(isoDateStringToDate(firstAvailability.endDateTime), 1),
    UI_TIME_FORMAT,
  );
  const datePrefix = showDatePrefix
    ? `${formatDate(startDate, UI_DATE_FORMAT_SHORT)}: `
    : '';

  return (
    <View
      style={{
        borderRadius: 8,
        paddingVertical: theme.paddingHorizontalHalf,
        paddingHorizontal: theme.paddingHorizontal,
        backgroundColor: availabilityCategory.backgroundColour,
        alignItems: 'center',
        flexDirection: 'row',
        gap: theme.paddingHorizontal,
      }}
    >
      {!!showIcon && <Icon source={ICONS.CalendarDayLight} />}
      <Txt lineHeightNone={true}>
        <Txt lineHeightNone={true} size="xsmall">
          {`Available: ${availabilityCategory.text}\n`}
          <Txt size="xxxsmall" lineHeightNone={true}>
            {`${datePrefix}${startTime} – ${endTime}`}
          </Txt>
        </Txt>
      </Txt>
    </View>
  );
};
